<template>
  <div>
    <template v-if="me.role == null">
      <div style="height: 500px; width: 500px; background-color: transparent">
        &nbsp;{{ me }}
      </div>
    </template>
    <template v-else-if="me.role === $roles.FOREIGNER">
      <ForeignerDashboard />
    </template>
    <template v-else>
      <Dashboard />
    </template>
  </div>
</template>

<script>
import { authComputed } from '@/vuex/helpers';
import { mapState } from 'vuex';
import ForeignerDashboard from '@/components/Foreigner/ForeignerDashboard';
import Dashboard from '@/views/admin/dashboard/Dashboard.vue';

export default {
  components: {
    Dashboard,
    ForeignerDashboard,
  },
  computed: {
    ...authComputed,
    ...mapState({
      me: (state) => state.v2.shared.profile.me,
    }),
  },
};
</script>
